import PropTypes from "prop-types";
import { Typography } from "@mui/material";

export default function ScenarioTitle({ year, timePeriod }) {
  const YEAR_TO_LABEL = {
    openingYear: "Opening Year ",
    designYear: "Design Year ",
  };

  const PERIOD_TO_LABEL = {
    amPeak: "AM Peak",
    pmPeak: "PM Peak",
    weekendPeak: "Weekend Peak",
  };

  return (
    <>
      <div style={{ display: "flex", alignItems: "baseline" }}>
        <Typography sx={{ marginLeft: "10px" }} variant="h6">
          {`${YEAR_TO_LABEL[year]} - ${PERIOD_TO_LABEL[timePeriod]}`}
        </Typography>
      </div>
    </>
  );
}

ScenarioTitle.propTypes = {
  year: PropTypes.string.isRequired,
  timePeriod: PropTypes.string.isRequired,
};
